import React, { useEffect, createElement } from 'react';
import { motion } from 'framer-motion';
import { SEOHead } from '../components/SEOHead';
export function AboutUs() {
  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = 'ld-breadcrumb-about';
    script.textContent = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [{
        '@type': 'ListItem',
        position: 1,
        name: 'Home',
        item: window.location.origin + '/'
      }, {
        '@type': 'ListItem',
        position: 2,
        name: 'About Us',
        item: window.location.origin + '/about'
      }]
    });
    document.head.appendChild(script);
    return () => {
      document.getElementById('ld-breadcrumb-about')?.remove();
    };
  }, []);
  return <main className="min-h-screen bg-light" data-id="element-339">
      <SEOHead title="About Us | Smith & Jengs Cleaning Services" description="Learn about Smith & Jengs, Bicester's trusted cleaning company. Professional, eco-friendly cleaning services with a 100% satisfaction guarantee." data-id="element-340" />
      {/* Dark Page Hero */}
      <section className="bg-primary pt-36 md:pt-44 pb-16 md:pb-24 relative overflow-hidden" data-id="element-341">
        <div className="absolute inset-0 opacity-10 pointer-events-none" style={{
        backgroundImage: 'radial-gradient(rgba(255,255,255,0.15) 1px, transparent 1px)',
        backgroundSize: '24px 24px'
      }} data-id="element-342"></div>
        <div className="container mx-auto px-6 md:px-12 relative z-10 text-center" data-id="element-343">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-344">
            <h1 className="text-5xl md:text-7xl lg:text-8xl font-heading font-bold text-white uppercase leading-none tracking-tight" data-id="element-345">
              About Us
            </h1>
          </motion.div>
        </div>
      </section>

      {/* Mission Banner */}
      <section className="container mx-auto px-6 md:px-12 py-16 md:py-24" data-id="element-346">
        <div className="grid grid-cols-1 md:grid-cols-2 shadow-xl rounded-2xl overflow-hidden" data-id="element-347">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-accent p-12 md:p-16 flex flex-col justify-center text-white" data-id="element-348">
            <h2 className="text-3xl md:text-4xl font-heading font-bold mb-6" data-id="element-349">
              Our goal is to make your life easier
            </h2>
            <p className="text-lg text-white/90 leading-relaxed" data-id="element-350">
              We make life easier for our clients by providing easy, reliable
              solutions for all their residential and commercial cleaning needs
              backed by world-class customer service.
            </p>
          </motion.div>
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="h-64 md:h-auto" data-id="element-351">
            <img src="https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?auto=format&fit=crop&w=800&q=80" alt="Cleaning service" className="w-full h-full object-cover" data-id="element-352" />
          </motion.div>
        </div>
      </section>

      {/* Experience Heading */}
      <section className="container mx-auto px-6 md:px-12 py-8 text-center" data-id="element-353">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-3xl md:text-5xl font-heading font-bold text-primary" data-id="element-354">
          With many years of experience, rest assured you're in good hands
        </motion.h2>
      </section>

      {/* Three Columns */}
      <section className="container mx-auto px-6 md:px-12 py-16" data-id="element-355">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12" data-id="element-356">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} data-id="element-357">
            <h3 className="text-2xl font-heading font-bold text-primary mb-4" data-id="element-358">
              Our Vision
            </h3>
            <p className="text-gray-600 leading-relaxed" data-id="element-359">
              To lead the residential and commercial cleaning industry by
              providing the highest level of customer service and quality of
              work. Our goal is to delight each and every one of our customers
              by meeting their specific cleaning requirements using our
              stringent operating standards.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} data-id="element-360">
            <h3 className="text-2xl font-heading font-bold text-primary mb-4" data-id="element-361">
              Our Mission
            </h3>
            <p className="text-gray-600 leading-relaxed" data-id="element-362">
              To provide first-class cleaning services through an unparalleled
              level of professionalism, supported by a flexible online and
              offline approach so you can make time for what matters most: YOU!
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.3
        }} data-id="element-363">
            <h3 className="text-2xl font-heading font-bold text-primary mb-4" data-id="element-364">
              Our Values
            </h3>
            <ul className="space-y-3 text-gray-600" data-id="element-365">
              <li data-id="element-366">
                <strong className="text-primary" data-id="element-367">People:</strong> Our business
                is people
              </li>
              <li data-id="element-368">
                <strong className="text-primary" data-id="element-369">Pride:</strong> We take pride
                in what we do
              </li>
              <li data-id="element-370">
                <strong className="text-primary" data-id="element-371">Reliability:</strong> We do
                what we say we'll do
              </li>
              <li data-id="element-372">
                <strong className="text-primary" data-id="element-373">Team:</strong> We bring out the
                best in each other
              </li>
              <li data-id="element-374">
                <strong className="text-primary" data-id="element-375">Quality:</strong> We constantly
                improve
              </li>
            </ul>
          </motion.div>
        </div>
      </section>

      {/* Our Guarantee */}
      <section className="relative overflow-hidden bg-primary py-20 md:py-28" data-id="element-376">
        {/* Decorative dot pattern */}
        <div className="absolute inset-0 opacity-10 pointer-events-none" style={{
        backgroundImage: 'radial-gradient(rgba(255,255,255,0.15) 1px, transparent 1px)',
        backgroundSize: '24px 24px'
      }} data-id="element-377"></div>

        {/* Decorative teal glow */}
        <div className="absolute -top-32 -right-32 w-96 h-96 bg-accent/10 rounded-full blur-3xl pointer-events-none" data-id="element-378"></div>
        <div className="absolute -bottom-32 -left-32 w-96 h-96 bg-accent/10 rounded-full blur-3xl pointer-events-none" data-id="element-379"></div>

        <div className="container mx-auto px-6 md:px-12 relative z-10" data-id="element-380">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.7
        }} className="max-w-4xl mx-auto text-center" data-id="element-381">
            {/* Shield icon */}
            <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-accent/15 mb-8" data-id="element-382">
              <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="text-accent" data-id="element-383">
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" data-id="element-384" />
                <path d="m9 12 2 2 4-4" data-id="element-385" />
              </svg>
            </div>

            <h3 className="text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-white uppercase tracking-tight mb-2" data-id="element-386">
              Our{' '}
              <span className="font-script text-accent lowercase tracking-normal font-normal text-5xl md:text-6xl lg:text-7xl" data-id="element-387">
                Guarantee
              </span>
            </h3>

            <div className="w-16 h-0.5 bg-gold mx-auto my-8" data-id="element-388"></div>

            <p className="text-xl md:text-2xl text-white/85 leading-relaxed font-light max-w-3xl mx-auto" data-id="element-389">
              We provide a{' '}
              <span className="text-accent font-medium" data-id="element-390">
                100% satisfaction guarantee
              </span>
              . If you're unhappy with our work we'll give you a full refund or
              a re-do. Our business was built on community reputation and that
              means everything to us.
            </p>

            <div className="mt-10 flex items-center justify-center gap-8" data-id="element-391">
              <div className="flex items-center gap-3" data-id="element-392">
                <div className="w-3 h-3 rounded-full bg-accent" data-id="element-393"></div>
                <span className="text-white/70 text-sm font-medium uppercase tracking-wider" data-id="element-394">
                  Full Refund
                </span>
              </div>
              <div className="flex items-center gap-3" data-id="element-395">
                <div className="w-3 h-3 rounded-full bg-accent" data-id="element-396"></div>
                <span className="text-white/70 text-sm font-medium uppercase tracking-wider" data-id="element-397">
                  Free Re-do
                </span>
              </div>
              <div className="flex items-center gap-3" data-id="element-398">
                <div className="w-3 h-3 rounded-full bg-accent" data-id="element-399"></div>
                <span className="text-white/70 text-sm font-medium uppercase tracking-wider" data-id="element-400">
                  100% Satisfaction
                </span>
              </div>
            </div>
          </motion.div>
        </div>
      </section>
    </main>;
}